import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '../lib/components/atomic/button';

export const NotFoundPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Typography
        variant="h1"
        color="primary.main"
        fontSize="6rem"
        fontWeight="bold"
        marginBottom="2rem"
      >
        404
      </Typography>
      <Button onClick={() => navigate(-1)}>{t('common:BACK')}</Button>
    </Box>
  );
};
